<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Table" });
import "tailwindcss/tailwind.css";
</script>

<table class = 's8-table'>

    {#if 'header' in $$slots}
        <thead><slot name = 'header'></slot></thead>
    {/if}

    <tbody>
        <slot name = 'body'></slot>
    </tbody>

    {#if 'footer' in $$slots}
        <tfoot><slot name = 'footer'></slot></tfoot>
    {/if}

</table>

<style>

    table.s8-table {
        width: 100%;
    }

        table.s8-table thead :global(th),
        table.s8-table thead :global(td) {
            background-color: rgba(39,39,17,0.02);
        }

        table.s8-table :global(td),
        table.s8-table :global(th) {
            padding: 5px;
            border-top: 1px solid rgba(39,39,17,0.06);
            border-bottom: 1px solid rgba(39,39,17,0.06);
        }

        table.s8-table :global(th) {
            font-weight: 400;
            text-align: left;
        }</style>